import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import MainContext from 'MainContext';
import Switch from 'components/switch';
import { Space } from 'components/wrapper';
import axios from 'axios';
import { updateUserProfile } from 'containers/login/container/api';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StyledIcon = styled.div`
  width: 1.145vw;
  height: 1.145vw;
  
  align-items: center;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 1.5vw;

  /* Responsive styles for smaller screens */
  @media (max-width: 480px) {
    margin-top: 0.2vw;  
  }  
`;
const StyledIconMoon = styled.div`
  width: 1.145vw;
  height: 1.145vw;
  align-items: center;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 1.5vw;
  }  
`;

const Wrapper = styled.div`
  position: relative;
  border-radius: 3.487vw;
  height: 3.487vw;
  width: calc(100% - 0.52vw);
  margin-top: 0.26vw;
  margin-left: ${(props) => (props.rtlDirection ? 'unset' : '0.26vw')};
  margin-right: ${(props) => (props.rtlDirection ? '0.26vw' : 'unset')};
  font-size: 0.728vw;
  font-weight: normal;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.textSecondary};
  transition: 200ms linear;
  &:hover {
    background-color: ${(props) => props.theme.pure};
    cursor: pointer;
  }
`;

const Circle = styled.div`
  width: 2.08vw;
  height: 2.08vw;
  margin-left: ${(props) => (props.rtlDirection ? '0.624vw' : '1.04vw')};
  margin-right: ${(props) => (props.rtlDirection ? '1.04vw' : '0.624vw')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 300ms linear;
  background-color: ${(props) => props.theme.borderBackground};
`;

const Line = styled.div`
  width: calc(100% - 2.08vw);
  margin-left: 1.04vw;
  margin-right: 1.04vw;
  height: 0;
  border-bottom: 1px solid ${(props) => props.theme.borderBackground};
`;

const App = (props) => {
  const { darkThemeSelected, theme, setDarkThemeSelected, rtlDirection } = useContext(ThemeContext);
  const { setPrifleContext, setTokenContext } = useContext(MainContext).login;
  const { setShowSetting } = props;
  const { t } = useTranslation();

  const closeSetting = () => {
    setShowSetting(false);
  };

  const onLogoutClick = () => {
    localStorage.removeItem('layers-token');
    axios.defaults.headers.common.Authorization = '';
    setTokenContext('');
    setPrifleContext({});
    setShowSetting(false);
  };

  const onToggleClick = () => {
    let darkThemeSelectedHelper= !darkThemeSelected;
    updateUserProfile({ user_light_theme:!darkThemeSelectedHelper });
    setDarkThemeSelected(darkThemeSelectedHelper);
  };

  return (
    <>
      <Link to="/start" style={{ textDecoration: 'none' }}>
        <Wrapper rtlDirection={rtlDirection} theme={theme} onClick={closeSetting}>
          <Circle rtlDirection={rtlDirection} theme={theme}>
          <StyledIcon className="icon-bold-plus" theme={theme} />
          </Circle>
          {t('settings.Add New Order')}
        </Wrapper>
      </Link>
      <Link to="/dashboard" style={{ textDecoration: 'none' }}>
        <Wrapper rtlDirection={rtlDirection} theme={theme} onClick={closeSetting}>
          <Circle rtlDirection={rtlDirection} theme={theme}>
          <StyledIcon className="icon-orders" theme={theme} />
          </Circle>
          {t('settings.Orders')}
        </Wrapper>
      </Link>
      <Link to="/profile" style={{ textDecoration: 'none' }}>
        <Wrapper rtlDirection={rtlDirection} theme={theme} onClick={closeSetting}>
          <Circle rtlDirection={rtlDirection} theme={theme}>
          <StyledIcon className="icon-setting" theme={theme} />
          </Circle>
          {t('settings.Settings')}
        </Wrapper>
      </Link>
      <Line theme={theme} />
      <Wrapper rtlDirection={rtlDirection} theme={theme} onClick={onToggleClick}>
        <Circle rtlDirection={rtlDirection} theme={theme}>
          <StyledIconMoon className="icon-moon" theme={theme} />
        </Circle>
        {t('settings.Dark Mode')}
        <Space width={4} />
        <Switch active={darkThemeSelected} toggle={() => console.log()} />
      </Wrapper>
      <Wrapper rtlDirection={rtlDirection} theme={theme} onClick={onLogoutClick}>
        <Circle rtlDirection={rtlDirection} theme={theme}>
          <StyledIcon className="icon-logout" theme={theme} />
        </Circle>
        {t('settings.Logout')}
      </Wrapper>
    </>
  );
};

export default App;
